import { Pipe, PipeTransform } from '@angular/core';
import { renderPrice } from "@gea-waldviertler-website/gea-models";

@Pipe({
    name: "price",
    standalone: true
})
export class EuroPricePipe implements PipeTransform {
  transform(value: number | string | undefined) {
    return renderPrice(value)
  }
}
